<div class="map-toolbar" *ngIf="enabledFeature">
    <button
            matIconButton
            class="mat-icon-toggle-button"
            [class.selected]="displayPanel"
            type="button"
            matTooltip="{{ !displayPanel ? 'Heatmap Configuration' : 'Close Heatmap Config' }}"
            (click)="togglePanelDisplay()"
            matTooltipPosition="right">
        <mat-icon>bubble_chart</mat-icon>
    </button>

    <div class="toolbar-panel-container" [hidden]="!displayPanel">
        <mat-card class="heatmap-config-card">
            <mat-card-header>
                <mat-card-title class="config-title">
                    <mat-icon>bubble_chart</mat-icon>
                    Heatmap Configuration
                </mat-card-title>
            </mat-card-header>

            <mat-card-content class="config-content">
                <!-- Enable/Disable Toggle -->
                <div class="config-row toggle-row">
                    <label class="config-label">Enable Heatmap</label>
                    <mat-slide-toggle
                            [(ngModel)]="heatmapEnabled"
                            (ngModelChange)="onHeatmapEnabledChange()"
                            color="primary"
                            matTooltip="Toggle heatmap visibility"></mat-slide-toggle>
                </div>

                <mat-divider></mat-divider>

                <!-- Radius Slider -->
                <div class="config-row slider-row" [class.disabled]="!heatmapEnabled">
                    <label class="config-label">
                        Radius
                        <span class="config-value">{{ heatmapRadius }}</span>
                    </label>
                    <div class="slider-container">
                        <input
                                type="range"
                                [disabled]="!heatmapEnabled"
                                [min]="RADIUS_MIN"
                                [max]="RADIUS_MAX"
                                step="1"
                                [(ngModel)]="heatmapRadius"
                                (ngModelChange)="onRadiusChange()"
                                (input)="onRadiusChange()"
                                matTooltip="Adjust heatmap radius size"
                                class="config-slider"/>
                        <div class="slider-labels">
                            <span>{{ RADIUS_MIN }}</span>
                            <span>{{ RADIUS_MAX }}</span>
                        </div>
                    </div>
                </div>

                <!-- Blur Slider -->
                <div class="config-row slider-row" [class.disabled]="!heatmapEnabled">
                    <label class="config-label">
                        Blur
                        <span class="config-value">{{ heatmapBlur }}</span>
                    </label>
                    <div class="slider-container">
                        <input
                                type="range"
                                [disabled]="!heatmapEnabled"
                                [min]="BLUR_MIN"
                                [max]="BLUR_MAX"
                                step="1"
                                [(ngModel)]="heatmapBlur"
                                (ngModelChange)="onBlurChange()"
                                (input)="onBlurChange()"
                                matTooltip="Adjust heatmap blur intensity"
                                class="config-slider"/>
                        <div class="slider-labels">
                            <span>{{ BLUR_MIN }}</span>
                            <span>{{ BLUR_MAX }}</span>
                        </div>
                    </div>
                </div>
            </mat-card-content>

            <mat-card-actions class="config-actions">
                <button matButton (click)="resetToDefaults()" matTooltip="Reset to default values">
                    <mat-icon>restore</mat-icon>
                    Reset Defaults
                </button>
            </mat-card-actions>
        </mat-card>
    </div>
</div>
